import React, {CSSProperties, useEffect, useState} from 'react';
import {Button, ConfigProvider, DatePicker, Input, Table, theme, Tooltip} from "antd";
import {ColumnsType} from "antd/es/table";
import 'dayjs/locale/ko'; // 또는 사용하고자 하는 로케일에 맞게 변경
import locale from 'antd/locale/ko_KR';
import dayjs from "dayjs";
import {TB_MONITORING_BATCH, TB_MONITORING_BATCH_RETURN,} from "./data/MonitorMgrData";
import {formatDate, getCurrentDateTime} from "../../../../../Common/util/DateUtil";
import {procAdminService} from "../../../../../Common/util/ProcService";
import EllipsisDiv from "../../common/component/EllipsisDiv";

const MonitorBatch: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const { RangePicker } = DatePicker;

    /*
    const { data} = useCommonUseQuery<TB_MONITORING[]>(
        queryKey,
        () =>procAdminService<TB_MONITORING[]>("post", `${serviceCode}ADS24`, null));
    */
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TB_MONITORING_BATCH[]>([]);


    const curTime:string  = getCurrentDateTime();
    const toDay = curTime.substring(0, curTime.indexOf(" "));
    const [startDate, setStartDate] = useState<string>(`${toDay} 00:00:00`);
    const [endDate, setEndDate] = useState<string>(`${toDay} 23:59:59`);
    const [jobServiceNo,setJobServiceNo] = useState<string>('');
    const [jobName, setJobName] = useState<string>('');
    const [pagination, setPagination] = useState({
        showSizeChanger: false,
        current:1,
        pageSize: 15,
        total: 0,
    });
    const onSearch = (pageNo:number) => {
        setLoading(true);

        const requestParam = {
            startDate:startDate,
            endDate:endDate,
            jobServiceNo:jobServiceNo,
            jobName:jobName,
            pageNo:pageNo,
            pageSize:pagination.pageSize,
        }

        procAdminService<TB_MONITORING_BATCH_RETURN>("post", `${serviceCode}ADS26`, requestParam).then(
            (response:TB_MONITORING_BATCH_RETURN)=>{
                setData(response.tbMonitoringBatchJobs);
                setPagination({current: pageNo, pageSize: pagination.pageSize, showSizeChanger: pagination.showSizeChanger, total: response.total});
            }
        ).finally(()=>{
            setLoading(false);
        });
    }



    const handleTableChange = (pagination:any) => {
        const { current, pageSize } = pagination;
        onSearch(current);
    };

    const tableStyle:CSSProperties = {
        paddingLeft:'10px'
        , paddingRight:'10px'
        , paddingBottom: '9px'
        , margin:'0'
        , fontSize:'12px'
    }

    const columns: ColumnsType<TB_MONITORING_BATCH> = [

        {
            title: '추적ID',
            dataIndex: 'traceId',
            key: 'traceId',
            ellipsis:true,
            width:'170px',
            render: (text: string) =>
                <EllipsisDiv style={tableStyle} >
                    <Tooltip placement="top" arrow={false} title={text}>
                        {text}
                    </Tooltip>
                </EllipsisDiv>
            ,
        },
        {
            title: 'Job이름',
            dataIndex: 'jobName',
            key: 'jobName',
            render: (text: string) =>
                <div style={{ ...tableStyle, alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: 'Job서비스코드',
            dataIndex: 'jobServiceNo',
            key: 'jobServiceNo',
            render: (text: string) =>
                <div style={{ ...tableStyle,  alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: '배치시작시간',
            dataIndex: 'executeTime',
            key: 'executeTime',
            render: (text: string) =>
                <div style={{ ...tableStyle,  alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '배치종료시간',
            dataIndex: 'completeTime',
            key: 'completeTime',
            render: (text: string) =>
                <div style={{ ...tableStyle,  alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '수행시간',
            dataIndex: 'runTime',
            key: 'runTime',
            render: (text: boolean) =>
                <div style={{ ...tableStyle,  alignItems: 'center', justifyContent: 'center', width:80 }}>
                    {text} ms
                </div>
            ,
        },


    ];


    useEffect(()=>{
        onSearch(1);
    }, []);

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                    <ConfigProvider locale={locale}>
                        <RangePicker    style={{marginLeft : "5px"}}
                                        defaultValue={ [dayjs(startDate, 'YYYY-MM-DD HH:mm:ss'), dayjs(endDate, 'YYYY-MM-DD HH:mm:ss')] }
                                        value={[dayjs(startDate, 'YYYY-MM-DD HH:mm:ss'), dayjs(endDate, 'YYYY-MM-DD HH:mm:ss')]}
                                        format={'YYYY-MM-DD'}
                                        onChange={(e, dateStrings: [string, string])=>{
                                            setStartDate(`${dateStrings[0]} 00:00:00`);
                                            setEndDate(`${dateStrings[0]} 23:59:59`);
                                        }}
                        />
                    </ConfigProvider>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>

                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}} placeholder={"Job명"}
                        value={ jobName }
                        onChange={(e)=>{
                            setJobName(e.target.value);
                        }}
                />
                <Input style={{width:"150px", marginRight:"5px", marginLeft:"5px"}}
                        value={jobServiceNo}
                        onChange={(e)=>{
                            setJobServiceNo(e.target.value);
                        }}
                        placeholder={"Job서비스코드"}/>

                <Button style={{marginRight:"5px", marginLeft:"5px"}}type="primary" size="small" onClick={()=>{onSearch(1)}}>조회</Button>
            </div>
        </nav>
        <Table columns={columns}
                loading={loading}
                dataSource={data}
                pagination={pagination}
                rowKey="traceId"
                onChange={handleTableChange}
        />
        </>
    );
};

export default MonitorBatch;
